import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const ContactRecurringBookingStatsModal = Loadable({
  loader: () => import('../../pages/contacts/contact_recurring_booking_stats_modal'),
  loading: ModalPlaceholder,
});

angular.module('gym').value('ContactRecurringBookingStatsModal', ContactRecurringBookingStatsModal);
